import React, {Component, ReactNode} from 'react';
import {SubCriterionParameter, VALUETYPE} from "../../domain/criterion/subCriterionParameterDomain";
import {SubCriterion} from "../../domain/criterion/subCriterionDomain";
import {Table, TableBody, TableRow, TableRowColumn, TextField} from "material-ui";
import {ZzFlatButton} from "../../../core/components/buttons/buttons";
import {PERMISSION} from "../../../core/metamodel/metaConstant";
import {ProjectVersionParamValue} from "../../domain/project/projectVersionParameterValueDomain";
import {loc} from "../../../core/common/config/locales";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import sbToolParamsService from "../../service/paramsService";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {fieldStyles} from "../../../core/form/createForm";
import StyledSelect from "../../../core/components/fields/styledSelect";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface State {
}

interface Props {
  subCriterion: SubCriterion
  handleChangeValueState: (bool: boolean) => void
}

const addDeleteColumnStyle = {
  width: "80px"
}

@observer
class ParametersListForm extends Component<Props, State> {
  readonly errors = observable.map<string>();
  readonly newValuesRow = observable<any>([]);

  readonly booleanOptions = [{value: "true", label: loc.i18n`Yes`}, {value: "false", label: loc.i18n`No`}]

  initNewValueArray = (subCriterion: SubCriterion): void => {
    let newArray = new Array<string>(subCriterion.parameters.length).fill("");
    this.newValuesRow.replace(newArray)
  }

  componentDidMount() {
    this.initNewValueArray(this.props.subCriterion);
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any) {
    if (prevProps.subCriterion !== this.props.subCriterion) {
      this.initNewValueArray(this.props.subCriterion);
    }
  }

  private onValueChangeArray = (newValue: LovItem[], index: number) => {
    let newValueRow = this.newValuesRow;
    newValueRow[index] = newValue.map(v => String(v.value));
    this.setState({newValuesRow: newValueRow})
  }

  private onValueChange = (newValue: string, index: number) => {
    let newValueRow = this.newValuesRow;
    newValueRow[index] = newValue;
    this.setState({newValuesRow: newValueRow})
  }

  @action
  private onAdd = () => {
    if (!this.isValidRow()) {
      return;
    }
    let rowValues = this.newValuesRow;
    let subCriterion = this.props.subCriterion;
    let paramNumber = sbToolParamsService.getNextParamNumber(subCriterion);

    let criterionParams = subCriterion.parameters.sort(this.sortByNumber)

    rowValues.forEach((v, i) => {
      console.warn("added value", i, v)
      if (v instanceof Array) {
        let params: any[] = v as [];
        params.forEach(vp => {
          let param = new ProjectVersionParamValue({
            value: vp,
            paramNumber: paramNumber,
            projectVersion: SbToolProjectVersionService.projectVersion,
            parameter: criterionParams[i],
            count: 1,
            $new: true
          })
          param.initAfterRead(true);
          sbToolParamsService.paramsValues.push(param)
        })
      } else {
        let param = new ProjectVersionParamValue({
          value: v,
          paramNumber: paramNumber,
          projectVersion: SbToolProjectVersionService.projectVersion,
          parameter: criterionParams[i],
          count: 1,
          $new: true
        })
        param.initAfterRead(true);
        sbToolParamsService.paramsValues.push(param)
      }
    })
    console.warn("params after all push", sbToolParamsService.paramsValues)

    this.initNewValueArray(this.props.subCriterion);
    this.props.handleChangeValueState(true)
  }

  @action
  private onDelete = (paramNumber: number) => {
    let paramValuesCurrentSubCriterion = sbToolParamsService.paramsValues.filter(p => {
      return p.paramNumber !== paramNumber && this.props.subCriterion.parameters.find(par => par.paramId === p.parameter.paramId) !== undefined
    })
    let paramValuesAnotherCriteria = sbToolParamsService.paramsValues.filter(p => {
      return this.props.subCriterion.parameters.find(par => par.paramId === p.parameter.paramId) === undefined
    })

    paramValuesCurrentSubCriterion.push(...paramValuesAnotherCriteria)

    sbToolParamsService.paramsValues.replace(paramValuesCurrentSubCriterion)
    sbToolParamsService.recalculateParamsNumbers()
    this.props.handleChangeValueState(true)
  }

  private isValidRow = (): boolean => {
    this.errors.clear();
    this.newValuesRow.forEach((value, index) => {
      let param = this.props.subCriterion.parameters[index];
      let valueType = param.valueType;
      let paramIndex = String(index);

      //For optional parameter there is currently no validation
      if (param.optional) {
        return;
      }

      if (!value || (typeof value === "string" && value.trim().length) === 0) {
        this.errors.set(paramIndex, loc.i18n`Parameter is empty`);
      } else if (valueType === VALUETYPE.NUMBER && isNaN(Number(value))) {
        this.errors.set(paramIndex, loc.i18n`Parameter should be number`);
      } else if (valueType === VALUETYPE.PERCENTS && isNaN(Number(value))) {
        this.errors.set(paramIndex, loc.i18n`Parameter should be number`);
      } else if (valueType === VALUETYPE.PERCENTS && Number(value) > 100) {
        this.errors.set(paramIndex, loc.i18n`Parameter should be 100 or less`);
      }
    });

    return this.errors.size === 0;
  };

  private renderAddRow = (): ReactNode => {
    let subCriterion = this.props.subCriterion;
    console.warn("subCriterion", subCriterion)
    let params = subCriterion.parameters.sort(this.sortByNumber)
    let columns = params.map((p, index) => {
      let value: string = this.newValuesRow[index]
      if (p.valueType === VALUETYPE.NUMBER || p.valueType === VALUETYPE.STRING || p.valueType === VALUETYPE.PERCENTS) {
        return <TextField
          {...fieldStyles.small.textField}
          key={p.number + "1"}
          type="string"
          style={{width: "100%"}}
          value={value}
          floatingLabelText={p.name}
          onChange={(e) => this.onValueChange(e.target.value, index)}
          errorText={this.errors.get(String(index))}/>
      } else if (p.valueType === VALUETYPE.PARAM_ID) {
        let options = p.parameters
          .sort((p1, p2) => p1.value - p2.value)
          .map(p => {
            return {label: p.label + " (" + p.value + ")", value: p.valueId}
          })
        return <StyledSelect
          {...fieldStyles.small.styledSelect}
          label={p.name}
          value={value}
          floatingLabelText={p.name}
          key={p.number}
          options={options}
          asterixForAll={false}
          style={{width: "100%"}}
          async={false}
          searchable={true}
          clearable={false}
          onChange={(e) => this.onValueChange(String(e.value), index)}
          errorText={this.errors.get(String(index))}/>
      } else if (p.valueType === VALUETYPE.BOOLEAN) {
        return <StyledSelect
          {...fieldStyles.small.styledSelect}
          label={p.name}
          value={value}
          floatingLabelText={p.name}
          key={p.number}
          options={this.booleanOptions}
          style={{width: "100%"}}
          async={false}
          clearable={false}
          onChange={(e) => this.onValueChange(String(e.value), index)}
          errorText={this.errors.get(String(index))}/>
      } else if (p.valueType === VALUETYPE.MULTI) {
        let options = p.parameters
          .sort((p1, p2) => p1.value - p2.value)
          .map(p => {
            return {label: p.label + " (" + p.value + ")", value: p.valueId}
          })
        return <StyledSelect
          {...fieldStyles.small.styledSelect}
          label={p.name}
          value={value}
          floatingLabelText={p.name}
          key={p.number}
          options={options}
          asterixForAll={false}
          style={{width: "100%"}}
          async={false}
          multi={true}
          searchable={true}
          clearable={false}
          onChange={e => this.onValueChangeArray(e, index)}
          errorText={this.errors.get(String(index))}/>
      } else {
        return <noscript/>
      }
    })
    return (
      <div style={{display: "flex", height: 60}}>
        {columns}
        <ZzFlatButton onClick={this.onAdd} permission={PERMISSION.Update} style={addDeleteColumnStyle}>
          <i className="fa fa-plus" aria-hidden="true"/>
        </ZzFlatButton>
      </div>
    )
  }

  private sortByNumber = (p1: SubCriterionParameter, p2: SubCriterionParameter): number => {
    return p1.number - p2.number
  }

  private renderTableBody = (): ReactNode => {
    return (
      <TableBody displayRowCheckbox={false}>
        {this.renderRows()}
      </TableBody>
    )
  }

  private renderRows = (): ReactNode[] => {
    let params = sbToolParamsService.paramsValues
      .filter(p => this.props.subCriterion.parameters.find(p1 => p1.paramId === p.parameter.paramId))
      .sort((p1, p2) => this.sortByNumber(p1.parameter, p2.parameter));

    if (params.length === 0) {
      return [];
    }
    let rows: ReactNode[] = [];
    let currentRowNumber = 1;
    let rowParams = params.filter(p => p.paramNumber === currentRowNumber)
    while (rowParams.length != 0) {
      let columns = rowParams.map((param, index) => {
        let text = param.value;
        if (param.parameter.valueType === VALUETYPE.PARAM_ID) {
          let paramValue = param.parameter.parameters.find(p => p.valueId === Number(param.value))
          text = paramValue ? paramValue.label : "-"
        } else if (param.parameter.valueType === VALUETYPE.BOOLEAN) {
          text = param.value == "true" ? "Ano" : "Ne"
        } else if (param.parameter.valueType === VALUETYPE.MULTI) {
          text = "";
          param.parameter.parameters
            .filter(p => p.valueId === Number(param.value))
            .forEach(p => {
              text += p.label + ", ";
            });
        }
        return (
          <OverlayTrigger
            placement="left"
            key={index}
            overlay={
              <Tooltip
                id="valueTooltip"
                style={{fontSize: 13}}
                className="left-aligned-tooltip"
              >
                {text}
              </Tooltip>
            }>
            <TableRowColumn key={index+""}>{text}</TableRowColumn>
          </OverlayTrigger>
        )
      })

      let row: ReactNode = <TableRow key={currentRowNumber}>
        {columns}
        {this.renderDeleteColumn(currentRowNumber)}
      </TableRow>
      rows.push(row);

      currentRowNumber++;
      rowParams = params.filter(p => p.paramNumber === currentRowNumber)
    }

    return rows;
  }

  private renderDeleteColumn = (paramNumber: number) => {
    return (
      <TableRowColumn style={addDeleteColumnStyle}>
        <ZzFlatButton onClick={() => this.onDelete(paramNumber)} permission={PERMISSION.Update}>
          <i className="fa fa-minus" aria-hidden="true"/>
        </ZzFlatButton>
      </TableRowColumn>
    )
  }

  render() {
    return (
      <div style={{marginTop: 20, width: "100%"}}>
        {this.renderAddRow()}
        <Table selectable={false}>
          {this.renderTableBody()}
        </Table>

      </div>
    )
  }
}

export default ParametersListForm;






// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/parametersListForm.tsx